import { Component } from '@angular/core';

@Component({
  selector: 'app-rp-target-audience-section',
  templateUrl: './target-audience-section.component.html',
  styleUrls: ['./target-audience-section.component.scss'],
})
export class TargetAudienceSectionComponent {
  audiences = [
    {
      icon: 'tabler:building-skyscraper',
      textKey: 'recruiterProgram.targetAudience.items.hiringManagers.description',
    },
    {
      icon: 'tabler:users-group',
      textKey: 'recruiterProgram.targetAudience.items.hrTeams.description',
    },
    {
      icon: 'tabler:briefcase',
      textKey: 'recruiterProgram.targetAudience.items.recruitmentAgencies.description',
    },
    {
      icon: 'tabler:target-arrow',
      textKey: 'recruiterProgram.targetAudience.items.organizations.description',
    },
  ];
}
